namespace GeniuzPOS.Purchase {
    export interface PoPo06DtPendingCNforCnrtvRow {
        Id?: number;
        SysDocNo?: string;
        UseFg?: number;
        WhsId?: string;
        LineItemNo?: number;
        SkuCode?: string;
        SkuDesc?: string;
        PurUnitPrice?: number;
        Qty?: number;
        PurUnit?: string;
        DiscAmt?: number;
        ItemAmt?: number;
        Remark?: string;
    }

    export namespace PoPo06DtPendingCNforCnrtvRow {
        export const idProperty = 'Id';
        export const nameProperty = 'SysDocNo';
        export const localTextPrefix = 'Purchase.PoPo06DtPendingCNforCnrtv';
        export const lookupKey = 'Purchase.PoPo06DtPendingCNforCnrtv';

        export function getLookup(): Q.Lookup<PoPo06DtPendingCNforCnrtvRow> {
            return Q.getLookup<PoPo06DtPendingCNforCnrtvRow>('Purchase.PoPo06DtPendingCNforCnrtv');
        }
        export const deletePermission = '*';
        export const insertPermission = '*';
        export const readPermission = '*';
        export const updatePermission = '*';

        export declare const enum Fields {
            Id = "Id",
            SysDocNo = "SysDocNo",
            UseFg = "UseFg",
            WhsId = "WhsId",
            LineItemNo = "LineItemNo",
            SkuCode = "SkuCode",
            SkuDesc = "SkuDesc",
            PurUnitPrice = "PurUnitPrice",
            Qty = "Qty",
            PurUnit = "PurUnit",
            DiscAmt = "DiscAmt",
            ItemAmt = "ItemAmt",
            Remark = "Remark"
        }
    }
}
